package ir.hosen.resume.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover

val InterestStyle = CssStyle {
    base {
        Modifier.transform { scale(1.1) }
    }
    hover {
        Modifier.transform { scale(1.2) }
    }
}